var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.375,
    height: 26.375,
    viewBox: "0 0 26.375 26.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11953",
    "data-name": "Path 11953",
    d: "M29.375,22.5v5.528a2.764,2.764,0,0,1-2.764,2.764H7.264A2.764,2.764,0,0,1,4.5,28.028V22.5",
    transform: "translate(0 -1.417)",
    fill: "none",
    stroke: "#174a84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11954",
    "data-name": "Path 11954",
    d: "M10.5,15l6.91,6.91L24.319,15",
    transform: "translate(-0.472 -0.826)",
    fill: "none",
    stroke: "#174a84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11955",
    "data-name": "Path 11955",
    d: "M18,21.083V4.5",
    transform: "translate(-1.063)",
    fill: "none",
    stroke: "#174a84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.394d9ffa122771238f2c0e1a19d3cd11.svg";
export { ForwardRef as ReactComponent };